import { useState } from 'react';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { setSystemNotification } from '../../../../store/system/system.action.js';
import { useDispatch } from 'react-redux';

// styles
import {
    ReferralCodeUploaderContainer,
    InputContainer,
    ButtonContainer
} from './ReferralCodeUploaderWidget.styles.js';

// components
import InputBar from '../../../../components/input-bar/InputBar.js';
import PrimaryBtn from '../../../../components/btns/primary-btn/PrimaryBtn.js';

export default function ReferralCodeUploaderWidget() {
    const [referralCode, setReferralCode] = useState('');
    const [isUploading, setIsUploading] = useState(false);
    const [uploadStatus, setUploadStatus] = useState('');
    
    const dispatch = useDispatch();
    const functions = getFunctions();

    const handleReferralCodeChange = (value) => {
        setReferralCode(value);
        setUploadStatus(''); // Clear any previous status
    };

    const handleUploadReferralCode = async () => {
        if (!referralCode.trim()) {
            setUploadStatus('Please enter a referral code');
            return;
        }

        setIsUploading(true);
        setUploadStatus('');

        try {
            // Call Firebase function to upload referral code
            const uploadReferralCodeFunction = httpsCallable(functions, 'uploadReferralCode');
            const result = await uploadReferralCodeFunction({ 
                referralCode: referralCode.trim() 
            });


            if (result.data.success) {
                setUploadStatus('Referral code uploaded successfully!');
                setReferralCode(''); // Clear input after successful upload
                dispatch(setSystemNotification('Referral code uploaded successfully!'));
            } else {
                setUploadStatus(result.data.message || 'Failed to upload referral code');
            }
        } catch (error) {
            console.error('Error uploading referral code:', error);
            setUploadStatus('Error uploading referral code. Please try again.');
        } finally {
            setIsUploading(false);
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            handleUploadReferralCode();
        }
    };

    return (
        <ReferralCodeUploaderContainer className="widget-bg">
            <h3>Upload Referral Code</h3>
            
            <InputContainer>
                <InputBar
                    type="text"
                    id="referralCodeInput"
                    pH="Enter referral code"
                    value={referralCode}
                    updateValue={handleReferralCodeChange}
                    onKeyPress={handleKeyPress}
                    disabled={isUploading}
                />
                
                <ButtonContainer>
                    <PrimaryBtn 
                        title={isUploading ? "UPLOADING..." : "UPLOAD"} 
                        onClick={handleUploadReferralCode}
                        disabled={isUploading || !referralCode.trim()}
                    />
                </ButtonContainer>
            </InputContainer>

            {uploadStatus && (
                <div style={{ 
                    marginTop: '12px', 
                    padding: '8px 12px', 
                    borderRadius: '4px',
                    backgroundColor: uploadStatus.includes('successfully') ? '#d4edda' : '#f8d7da',
                    color: uploadStatus.includes('successfully') ? '#155724' : '#721c24',
                    border: `1px solid ${uploadStatus.includes('successfully') ? '#c3e6cb' : '#f5c6cb'}`
                }}>
                    {uploadStatus}
                </div>
            )}
        </ReferralCodeUploaderContainer>
    );
}
